export const CONTACT = {
  company: "Heavy Duty Detailing",
  owner: "Dylan Moore",
  phone: "902-809-5779",
  phoneHref: "tel:+19028095779",
  email: "dylan.moore@heavydutydetailing.net",
  emailHref: "mailto:dylan.moore@heavydutydetailing.net",
  region: "Dartmouth, NS — servicing all of Nova Scotia",
  mobile: "Mobile service — we come to you",
};

export const PRICING_SHEET =
  "https://customer-assets-v7afamib.emergentagent.net/job_truck-detail-book/artifacts/a1cl0qgt_PRICING%20SHEET.png";

export const IMAGES = {
  hero: "https://images.pexels.com/photos/13569837/pexels-photo-13569837.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  green: "https://images.pexels.com/photos/33262905/pexels-photo-33262905.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  redMan: "https://images.unsplash.com/photo-1760944016312-93ac6f9402fe?auto=format&fit=crop&w=1200&q=80",
  blackShiny: "https://images.unsplash.com/photo-1778162153194-8649950fd490?auto=format&fit=crop&w=1200&q=80",
  colorRow: "https://images.pexels.com/photos/4320464/pexels-photo-4320464.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  bwRow: "https://images.pexels.com/photos/2348359/pexels-photo-2348359.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
};

export const MANIFESTO = [
  {
    n: "01",
    title: "Aluminum That Actually Shines",
    body: "Wheels, fuel tanks, battery boxes, DPF covers — hand-polished to a mirror finish. We don't cut corners, we cut haze and oxidation.",
  },
  {
    n: "02",
    title: "We Come To You",
    body: "Fully mobile out of Dartmouth and servicing all of Nova Scotia. Your yard, your terminal, your driveway — the truck stays working while we work.",
  },
  {
    n: "03",
    title: "One Truck At A Time",
    body: "Owner-operated and hands-on from start to finish. Every unit gets the full attention it deserves — inside, outside, and every inch in between.",
  },
];

export const CORE_SERVICES = [
  { name: "Wash & Detail Only", price: "$300 – $575", note: "Full clean, priced to the unit" },
  { name: "Basic Heavy Duty Detail", price: "$1,500", note: "6 wheels + 1 fuel tank" },
  { name: "Wheels", price: "$45 / wheel", note: "6 wheels: $270" },
  { name: "Polished Fuel Tank", price: "$335", note: "Mirror-finish aluminum" },
  { name: "Interior Detail", price: "$175", note: "Cab deep clean" },
  { name: "Exterior Wash & Wax", price: "$350", note: "Protective finish" },
  { name: "Iron & Bug Removal", price: "$100", note: "Contaminant strip" },
  {
    name: "Exterior Finish Enhancement Package",
    price: "$270",
    note: "Tire shine, windows, sticker/vinyl removal, wipe down, door jams, hand dry, frame wipe, scratch removal",
  },
];

export const ADDON_SERVICES = [
  { name: "DPF Cover Polishing", price: "$175" },
  { name: "Unpolished Fuel Tank", price: "$430" },
  { name: "Additional Fuel Tanks", price: "$335" },
  { name: "Battery Box Cover Polishing", price: "$220" },
  { name: "Hub & Nut Cover Kit Installing", price: "$40" },
  { name: "Floor Mat Install", price: "No Charge" },
];

export const SERVICE_OPTIONS = [
  "Wash & Detail Only",
  "Basic Heavy Duty Detail",
  "Wheels",
  "Polished Fuel Tank",
  "Interior Detail",
  "Exterior Wash & Wax",
  "Iron & Bug Removal",
  "Exterior Finish Enhancement Package",
  "Add-on / Polishing Work",
  "Not sure — need a quote",
];
